import { h } from 'preact';
import { SocialImageCreative } from '../../common/creative/social';
import { FacebookFooter } from '../../common/creative/social/facebook-footer';
import { FacebookHeader } from '../../common/creative/social/facebook-header';

interface FBImageProps {
  videoSlot?: HTMLVideoElement;
}

export function FBImage(props: FBImageProps) {
  return (
    <SocialImageCreative
      videoSlot={props.videoSlot}
      header={<FacebookHeader lines={3} />}
      footer={<FacebookFooter />}
    />
  );
}
